<template>
  <div id="app">
    <keep-alive>
      <router-view style="width: 100%;height: 100%" />
    </keep-alive>
    <!-- <router-view style="width: 100%;height: 100%" /> -->
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
html,body{
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
   
}
.el-menu-item{
      color: black !important;
   }
</style>
